import { createBrowserRouter } from 'react-router';

import { TrackingLayout } from '@/components/layout/TrackingLayout.tsx';
import { NotFoundPage } from '@/pages/NotFoundPage.tsx';
import { VerificationPage } from '@/pages/track/VerificationPage.tsx';

export const router = createBrowserRouter([
  {
    element: <TrackingLayout />,
    children: [
      {
        path: '/track/:publicId',
        element: <VerificationPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
